import React from "react";
import bindAll from 'lodash.bindall';
import styles from './operation-button.css';
import Button from 'antd/lib/button'
import {connect} from 'react-redux';
import { getEnv, Environment } from "../../../lib/xes/xes";

class SubmitButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      maximize: false
    }
    bindAll(this, [
      'handleMaximize'
    ])
    this.env = getEnv()
    this.isSupportEnv = [Environment.BAIZE].includes(this.env) ? true : false
  }
  componentDidUpdate(preProps) {
  }
  handleMaximize() {
    window.parent.postMessage({
      // sync 来自同步练
      from: 'sync',
      // 传递操作类型
      type: 'toggleFullScreen',
      // 附加数据
      data: {
        // 是否全屏，如果要全屏就传true 否则 就传false
        fullscreen: !this.state.maximize
      }
    }, '*')
    this.setState({
      maximize: !this.state.maximize
    })
  }
  render() {
    if(!this.isSupportEnv) return null
    return (
      <div>
        <Button onClick={this.handleMaximize}
            style={{
                width: '5rem',
                color: '#4A82F7',
                borderRadius: '0.25rem',
                outline: 'none',
                border: 'none',
                fontSize: '0.88rem',
                fontWeight: '600'
            }}
            loading={this.state.loading}>{
            this.state.maximize ? '退出全屏' : '全屏'
        }</Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  state
})
const mapDispatchToProps = (dispatch) => ({
  dispatch
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubmitButton)
